import { View, StyleSheet, StyleProp, ViewStyle } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { getISOWeek } from "@/lib/helpers";
import { useTheme } from "@/hooks/useTheme";
import { useCalendarParams } from "@/lib/calendar";

type WeekBannerProps = {
  style?: StyleProp<ViewStyle>;
};

export function WeekBanner({ style }: WeekBannerProps) {
  const { colors } = useTheme();
  const { date, daysView } = useCalendarParams();

  const weeks = Array.from({ length: daysView }, (_, i) => {
    const newDate = new Date(date); // copy
    newDate.setDate(date.getDate() + i);
    return { week: getISOWeek(newDate), date: newDate };
  });

  const groupedWeeks = weeks.reduce(
    (acc, { week }) => {
      const found = acc.find((w) => w.week === week);
      if (found) {
        found.count++;
      } else {
        acc.push({ week, count: 1 });
      }
      return acc;
    },
    [] as { week: number; count: number }[],
  );

  return (
    <View style={[styles.container, style]}>
      <View style={[styles.weeks, style]}>
        {groupedWeeks.map((w, i) => (
          <ThemedText
            key={i}
            id={`${i}`}
            style={[
              { backgroundColor: colors.backgroundSecondary, borderColor: colors.border },
              { flexBasis: `${(w.count / daysView) * 100}%` },
              styles.week,
            ]}
          >
            W{w.week}
          </ThemedText>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "transparent",
    flexDirection: "row",
    paddingRight: 4,
    maxHeight: 24,
  },
  weeks: {
    backgroundColor: "transparent",
    maxHeight: 24,
    flexGrow: 1,
    flex: 1,
    flexDirection: "row",
    width: "100%",
  },
  message: {
    flex: 1,
    maxWidth: 50,
    minWidth: 50,
  },
  week: {
    flexGrow: 1,
    flexShrink: 1,
    fontSize: 14,
    textAlign: "center",
    borderRadius: 999,
    marginHorizontal: 1,
    borderWidth: StyleSheet.hairlineWidth,
  },
});
